import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { alpha } from "@mui/material/styles";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const STATUS_MAP = {
  active: { label: "Ativo", color: "success" },
  grace_period: { label: "Período de Carência", color: "warning" },
  cancelled: { label: "Cancelado", color: "error" },
  expired: { label: "Expirado", color: "error" },
  suspended: { label: "Suspenso", color: "default" },
};

const CYCLE_MAP = {
  monthly: "Mensal",
  trimestral: "Trimestral",
  annual: "Anual",
};

const formatDate = (dateStr) => {
  if (!dateStr) return "Sem expiração";
  const d = new Date(dateStr);
  return d.toLocaleDateString("pt-BR");
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value || 0);
};

export default function CurrentPlanCard({ subscription }) {
  if (!subscription) return null;

  const plan = subscription.plan_details;
  const statusInfo = STATUS_MAP[subscription.status] || STATUS_MAP.active;

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 3,
        background: (theme) =>
          `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.04)} 0%, ${alpha(theme.palette.primary.light, 0.08)} 100%)`,
        border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Typography
            variant="overline"
            sx={{ color: "text.secondary", letterSpacing: 1.5 }}
          >
            Plano Atual
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 700, mt: 0.5 }}>
            {plan?.name}
          </Typography>
        </Box>
        <Chip
          label={statusInfo.label}
          color={statusInfo.color}
          size="small"
          sx={{ fontWeight: 600 }}
        />
      </Stack>

      <Stack direction="row" spacing={3} sx={{ mt: 2.5 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <AutorenewIcon sx={{ fontSize: 18, color: "text.secondary" }} />
          <Typography variant="body2" color="text.secondary">
            Ciclo: <strong>{CYCLE_MAP[subscription.billing_cycle] || subscription.billing_cycle}</strong>
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <CalendarTodayIcon sx={{ fontSize: 18, color: "text.secondary" }} />
          <Typography variant="body2" color="text.secondary">
            {subscription.expires_at
              ? `Expira em: ${formatDate(subscription.expires_at)}`
              : "Sem expiração"}
          </Typography>
        </Stack>
      </Stack>

      {plan?.price_monthly > 0 && (
        <Typography
          variant="h5"
          sx={{ mt: 2, fontWeight: 600, color: "primary.main" }}
        >
          {formatCurrency(plan.price_monthly)}
          <Typography component="span" variant="body2" color="text.secondary">
            /mês
          </Typography>
        </Typography>
      )}

      {plan?.price_monthly === 0 && (
        <Typography
          variant="h5"
          sx={{ mt: 2, fontWeight: 600, color: "success.main" }}
        >
          Gratuito
        </Typography>
      )}
    </Box>
  );
}
